/**
 * Convert a value to a price with currency
 * @param {any} value
 * @param {string} currency
 */const getPrice = (value = '', currency = 'VND') => {
  // get the string which is converted from the value
  value = value ? String(value) : '';
  // replace all ',' to '.' (value)
  value = value.toUpperCase().replace(/\./g, ',');
  // default the result is equal to the value
  let result = value;
  // price is the number which is converted from the value
  let price = 0;
  // if the value has characters which are numbers
  if (value && value.match(/\d+/) && value.match(/\d+/).length) {
    price = Number(value.replace(/[^0-9]+/g, ''));
  }
  // if the price is a number which is greater than 0
  if (!isNaN(price) && price > 0) {
    result = price;
    // if the currency exists, add currency to the result
    if (currency) {
      result = price.toLocaleString('it-IT');
      if (result && result.trim() && result.trim().indexOf(currency) === -1) {
        result = `${result} ${currency}`;
      }
      result = result.replace(/,/g, '.');
    }
  }
  return result;
}

export {
  getPrice,
};



// WEBPACK FOOTER //
// ./lib/convert.js